import { useCallback } from 'react';

import type { User } from '../context';

export function useFetchUser(): {
    fetchUser: () => Promise<User | undefined>;
} {
	const fetchUser = useCallback(async (): Promise<User | undefined> => {
		try {
			const response = await fetch('/gateway/api/me', {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
				},
			});

			if (!response.ok) {
				return undefined;
			}

			const userData = await response.json();

			return userData;
		} catch (err) {
			return undefined;
		}
	}, []);

	return {
		fetchUser,
	};
}
